<template>
	<div class="gmoinput">
		<div class="logo">
			<img src="https://entry.universal-field.com/images/card/visa/new_visa.gif" height="34">
			<img src="https://entry.universal-field.com/images/card/master/MASTERCARD.GIF" height="34">
			<img src="https://entry.universal-field.com/images/card/jcb/JCB(B-1).gif" height="34">
			<img src="https://entry.universal-field.com/images/card/amex/amex_a.gif" height="34">
			<img src="https://entry.universal-field.com/images/card/diners/Diners_Logo_for_Merchant.jpg" height="34">
			<img src="https://entry.universal-field.com/images/card/discover/discover_logo.jpg" height="34">
		</div>
		<div class="row">
			<label class="col-sm-5 col-form-label">カード番号</label>
			<div class="col-sm-7">
				<input type="text" value="" class="form-control" v-model="creditCno">
			</div>
		</div>
		<div class="row">
			<label class="col-sm-5 col-form-label">セキュリティコード</label>
			<div class="col-sm-7">
				<input type="text" value="" class="form-control" v-model="creditSno">
			</div>
		</div>
		<div class="row">
			<label class="col-sm-5 col-form-label">有効期限</label>
			<div class="col-sm-7">
				<select v-model="creditLimitYear">
					<option v-for="year in selectYear" :key="year" :value="year">{{year}}</option>
				</select>年 / 
				<select v-model="creditLimitMonth">
					<option v-for="month in selectMonth" :key="month" :value="month">{{month}}</option>
				</select>月
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		props: {
		},
		data() {
			return {
			}
		},
		computed: {
			creditCno:{
				get:function() {
					return this.$store.getters['gmoStore/getCreditCno'];
				},
				set:function(newVal) {
					this.$store.commit('gmoStore/setCreditCno', newVal);
				}
			},
			creditSno:{
				get:function() {
					return this.$store.getters['gmoStore/getCreditSno'];
				},
				set:function(newVal) {
					this.$store.commit('gmoStore/setCreditSno', newVal);
				}
			},
			creditLimitYear:{
				get:function() {
					return this.$store.getters['gmoStore/getCreditLimitYear'];
				},
				set:function(newVal) {
					this.$store.commit('gmoStore/setCreditLimitYear', newVal);
				}
			},
			creditLimitMonth:{
				get:function() {
					return this.$store.getters['gmoStore/getCreditLimitMonth'];
				},
				set:function(newVal) {
					this.$store.commit('gmoStore/setCreditLimitMonth', newVal);
				}
			},
			selectYear() {
				const nowyear = new Date().getFullYear();
				const year = new Array(10).fill(nowyear).map((n,i) => n+i);
				return year;
			},
			selectMonth() {
				const month = new Array(12).fill(1).map((n,i) => n+i);
				return month;
			}
		},
		methods: {
		},
		mounted() {
		}
	};
</script>

<style lang="scss" scoped>
	.gmoinput {
		.logo {
			display: flex;
			justify-content: center;
			align-items: center;
			margin: 0 auto;
			img {
				margin: 0 4px;
				height: 34px;
			}
			
		}
	}
</style>
